import {message} from 'antd';

export function onSucess(title) {
  message.success(title);
}
